import React, { useEffect, useState } from "react";
import { Form } from "react-router-dom";
import "../CreateCompany/CreateCompany.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import axios from "../../API/axios";
import { getOwnCompaniesList } from "../../Services/apiService";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import useIndustryScopedMaster from "../../hooks/useIndustryScopedMaster";
import { mapCompanyOption } from "../../utils/industryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";
import SkillSuggestChips from "../../components/SkillSuggestChips";

const options = [
  { value: "Mumbai", label: "Mumbai" },
  { value: "Thane", label: "Thane" },
  { value: "Pune", label: "Pune" },
];

const AddJob = ({ showModal, closeModal, openModal, AllJobList }) => {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();
  useEscapeKeyDown(showModal, closeModal);
  const master = useIndustryScopedMaster({ language: localStorage.getItem("Lang"), sessionId });
  const [jobTitle, setjobTitle] = useState("");
  const [jobDescription, setjobDescription] = useState("");
  const [minimumSalary, setMinimumSalary] = useState("");
  const [maximumSalary, setMaximumSalary] = useState("");
  const [currency, setCurrency] = useState("");
  const [hashtags, setHashtags] = useState("");
  const [screeningQuestions, setScreeningQuestions] = useState([]);
  const language = localStorage.getItem("Lang");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const reset = () => {
    setjobTitle("");
    setjobDescription("");
    setMinimumSalary("");
    setMaximumSalary("");
    setCurrency("");
    setHashtags("");
    setScreeningQuestions([]);
    setCompanyData([]);
    setCityData([]);
    setWorkLocationData([]);
    setWorkTypeData([]);
    setsalaryData([]);
    setsourceTypeData([]);
    setJobTypeData([]);
    setCompanyId(null);
    master.resetMaster();
  };

  const addScreeningQuestion = () => {
    if (screeningQuestions.length >= 5) return;
    setScreeningQuestions((prev) => [...prev, ""]);
  };

  const updateScreeningQuestion = (index, value) => {
    setScreeningQuestions((prev) =>
      prev.map((q, i) => (i === index ? value : q))
    );
  };

  const removeScreeningQuestion = (index) => {
    setScreeningQuestions((prev) => prev.filter((_, i) => i !== index));
  };

  const saveScreeningQuestions = async (jobId) => {
    if (!jobId) return;
    const questions = screeningQuestions
      .map((q) => (typeof q === "string" ? q.trim() : ""))
      .filter(Boolean)
      .map((question, i) => ({
        question,
        idealAnswer: "",
        isOptional: false,
        mustHave: false,
        sortOrder: i,
      }));
    if (questions.length === 0) return;
    try {
      await axios.put("/Job/SetScreeningQuestions", {
        deviceType: "Web",
        sessionId,
        langKey: language === "en" ? "" : language,
        jobId,
        questions,
      });
    } catch (e) {
      console.log("SetScreeningQuestions failed", e);
    }
  };

  //********Company List Start  ********//
  const [companyData, setCompanyData] = useState([]);
  const [companyId, setCompanyId] = useState(null);

  const getCompany = async () => {
    try {
      const res = await getOwnCompaniesList();
      const data = res.map(mapCompanyOption);
      setCompanyData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCompany();
  }, []);
  //********Company List End  ********//

  //********Job Type List Start  ********//
  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeId, setJobTypeId] = useState(null);
  const getJobType = () => {
    axios
      .get(`Master/GetJobTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setJobTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getJobType();
  }, []);
  //********Job Type List End  ********//

  //********Work Level Type List Start  ********//
  const [workTypeData, setWorkTypeData] = useState([]);
  const [workTypeId, setWorkTypeId] = useState(null);
  const getWorkType = () => {
    axios
      .get(`Master/GetWorkLevelTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkType();
  }, []);
  //********Work Level Type List End  ********//

  //********Work Location Type List Start  ********//
  const [workLocationData, setWorkLocationData] = useState([]);
  const [workLocationId, setWorkLocationId] = useState(null);
  const getWorkLocationType = () => {
    axios
      .get(`Master/GetWorkLocationTypesDDL?LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkLocationData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getWorkLocationType();
  }, []);
  //********Work Location Type List End  ********//
  //********Salary Type List Start  ********//
  const [salaryData, setsalaryData] = useState([]);
  const [salaryId, setsalaryId] = useState(null);
  const getsalaryType = () => {
    axios
      .get(`Master/GetSalaryTypesDDL?LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.jbSlryTypId,
          label: item.name,
        }));
        setsalaryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getsalaryType();
  }, []);
  //********Salary Type List End  ********//
  //********Work Location Type List Start  ********//
  const [sourceTypeData, setsourceTypeData] = useState([]);
  const [sourceTypeId, setsourceTypeId] = useState("");
  const getsourceTypeType = () => {
    axios
      .get(`Master/GetSourceTypesDDL?LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setsourceTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getsourceTypeType();
  }, []);
  //********Work Location Type List End  ********//

  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);
  //********City List End  ********//

  const handleSubmit = async () => {
    try {
      const masterPayload = master.jobMasterPayload();
      if (
        jobTitle &&
        jobDescription &&
        minimumSalary &&
        maximumSalary !== "" &&
        companyId &&
        master.fitid &&
        masterPayload.designationName
      ) {
        const body = {
          deviceType: "Web",
          sessionId: sessionId,
          compUid: companyId,
          locationId: null,
          cityID: cityId,
          jbTypId: jobTypeId,
          workLevelType: workTypeId,
          workLocationType: workLocationId,
          designationName: masterPayload.designationName,
          industryId: masterPayload.industryId,
          skillIds: masterPayload.skillIds,
          skillNames: masterPayload.skillNames,
          salaryTypeId: salaryId,
          minSalary: minimumSalary,
          maxSalary: maximumSalary,
          currency: null,
          title: jobTitle,
          description: jobDescription,
          hashTags: hashtags,
          sourceTypeId: null,
          receiveApplicantsType: 1,
          langKey: language === "en" ? "" : language,
        };
        // console.log('body', body);
        const res = await axios.post("/Job/AddJob", body);
        const responseData = res.data?.responseData || {};
        const jobId =
          responseData?.id ??
          responseData?.Id ??
          responseData?.jobId ??
          responseData?.JobId ??
          responseData?.viewJob?.jobId ??
          null;
        if (jobId) {
          await saveScreeningQuestions(jobId);
        }
        const publishBlocked =
          responseData.publishBlocked ||
          responseData.PublishBlocked ||
          String(res.data?.status || "").toLowerCase() === "warning";
        AllJobList(1, true);
        if (publishBlocked) {
          const missing = responseData.missingFields || responseData.MissingFields || [];
          setWarningToastMessage(
            res.data?.message ||
              `Saved as draft. Add ${missing.length ? missing.join(", ") : "skills and match weights"} before publishing.`
          );
          setShowWarningToast(true);
          reset();
          closeModal();
          if (jobId) {
            window.dispatchEvent(
              new CustomEvent("wlj-fix-job", {
                detail: { jobId, field: missing[0] || "skills" },
              })
            );
          }
          return;
        }
        setToastMessage(res.data.message);
        setShowToast(true);
        reset();
        closeModal();
      }
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [showModal]);

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6>Add Job</h6>
                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={closeModal}
                >
                  close
                </span> */}
                <CloseSharpIcon className="material-symbols-sharp me-2 pointer"
                  onClick={closeModal}
                />
              </div>
              <Form onSubmit={(e) => e.preventDefault()}>
                <div className="row p-4 settings CreateCompany">
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("Newsfeed.Job Title")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={jobTitle}
                      onChange={(e) => setjobTitle(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("Newsfeed.Job Description")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      id="about"
                      name="about"
                      rows="4"
                      cols="50"
                      value={jobDescription}
                      onChange={(e) => setjobDescription(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("Newsfeed.Company Name")} <span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      value={companyData.find((option) => option.value === companyId) || null}
                      onChange={(option) => {
                        setCompanyId(option ? option.value : null);
                        if (option) {
                          master.applyCompanyIndustry(option);
                        } else {
                          master.resetMaster();
                        }
                      }}
                      options={companyData}
                      placeholder={t("Newsfeed.Search and Select Company Name")}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="industry">
                      {t("User Profile.Industry")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      value={master.industry}
                      onChange={master.onIndustryChange}
                      options={master.industryList}
                      placeholder={t("User Profile.Select industry")}
                      styles={customStyles}
                      isClearable
                    />
                  </div>
                  {/* <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Location Name </label>
                                        <Select
                                            options={options}
                                        />
                                    </div> */}
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                       {t("Newsfeed.City Name")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      defaultValue={cityId}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      noOptionsMessage={() => t("modals.Search and Select City")}
                      placeholder={t("SearchJob.Select City")}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("Newsfeed.Job Type")} <span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      defaultValue={jobTypeId}
                      onChange={(e) => {
                        setJobTypeId(e.value);
                      }}
                      options={jobTypeData}
                      placeholder= {t("Newsfeed.Search and Select Job Type")}
                      styles={customStyles}
                      isSearchable={false}

                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                       {t("User Profile.Work Level Type")} <span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      defaultValue={workTypeId}
                      onChange={(e) => {
                        setWorkTypeId(e.value);
                      }}
                      options={workTypeData}
                      placeholder={"Select Work Level Type"}
                      styles={customStyles}
                      isSearchable={false}

                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Work Location Type")}<span className="text-danger ms-2">*</span>
                    </label>
                    {/* <input type='text' /> */}
                    <Select
                      defaultValue={workLocationId}
                      onChange={(e) => {
                        setWorkLocationId(e.value);
                      }}
                      options={workLocationData}
                      placeholder={t("User Profile.Select Work Location Type")}
                      styles={customStyles}
                      isSearchable={false}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Designation")}<span className="text-danger ms-2">*</span>
                    </label>

                    <CreatableSelect
                      value={master.designation}
                      options={master.designationOptions}
                      placeholder={
                        master.fitid
                          ? t("modals.Search and Select Designation")
                          : t("User Profile.Select industry")
                      }
                      onMenuOpen={master.onDesignationMenuOpen}
                      onChange={master.setDesignation}
                      onMenuScrollToBottom={master.onDesignationMenuScroll}
                      onInputChange={master.onDesignationInputChange}
                      onCreateOption={master.createDesignation}
                      isDisabled={!master.fitid}
                      isClearable
                      isLoading={master.designationLoading}
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="skills">
                      {t("User Profile.Skills")}
                    </label>
                    <CreatableSelect
                      {...creatableSkillSelectDefaults}
                      value={master.skills}
                      options={master.skillOptions}
                      placeholder={
                        master.fitid
                          ? t("User Profile.Search and Select Skill")
                          : t("User Profile.Select industry")
                      }
                      onMenuOpen={master.onSkillMenuOpen}
                      onChange={(selected) => master.setSkills(selected || [])}
                      onMenuScrollToBottom={master.onSkillMenuScroll}
                      onInputChange={onCreatableInputChange(master.onSkillInputChange)}
                      onCreateOption={master.createSkill}
                      isDisabled={false}
                      isLoading={master.skillLoading}
                      styles={customStyles}
                    />
                    <SkillSuggestChips
                      title={jobTitle}
                      fitid={master.fitid}
                      selected={master.skills}
                      onAdd={(option) => {
                        const exists = (master.skills || []).some(
                          (s) => String(s.value) === String(option.value) || s.label === option.label
                        );
                        if (!exists) master.setSkills([...(master.skills || []), option]);
                      }}
                    />
                    <div className="small text-muted mt-1">
                      Publishing requires at least one skill and match weights. Incomplete posts are saved as draft.
                    </div>
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                       {t("Newsfeed.Salary Type")}<span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      defaultValue={salaryId}
                      onChange={(e) => {
                        setsalaryId(e.value);
                      }}
                      options={salaryData}
                      placeholder={t("Newsfeed.Select Salary Type")}
                      styles={customStyles}

                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      Minimum Salary <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={minimumSalary}
                      onChange={(e) => setMinimumSalary(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      Maximum Salary <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={maximumSalary}
                      onChange={(e) => setMaximumSalary(e.target.value)}
                    />
                  </div>
                  {/* <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Currency <span style={{ color: 'red' }}>*</span></label>
                                        <input type='text'
                                            value={currency}
                                            onChange={e => setCurrency(e.target.value)} />
                                    </div> */}

                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      Hashtags <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={hashtags}
                      onChange={(e) => setHashtags(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 mt-3">
                    <label htmlFor="screening-questions">
                      Screening questions
                    </label>
                    {screeningQuestions.map((question, index) => (
                      <div
                        key={`sq-${index}`}
                        className="d-flex align-items-center gap-2 mb-2"
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={question}
                          placeholder={`Question ${index + 1}`}
                          onChange={(e) =>
                            updateScreeningQuestion(index, e.target.value)
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeScreeningQuestion(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    {screeningQuestions.length < 5 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary mt-1"
                        onClick={addScreeningQuestion}
                      >
                        Add question
                      </button>
                    )}
                  </div>
                  {/* <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Source Type <span style={{ color: 'red' }}>*</span></label>
                                       
                                        <Select
                                            defaultValue={sourceTypeId}
                                            onChange={setsourceTypeId}
                                            options={sourceTypeData}
                                            placeholder={'Select Source Type'}
                                        />
                                    </div> */}
                  {/* <div className="col-md-12 mt-2">
                                        <label htmlFor="about">Receive Applicants Type <span style={{ color: 'red' }}>*</span></label>
                                        
                                        <Select
                                            options={options}
                                        />
                                    </div> */}

                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default AddJob;
